import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'customTime',
  standalone: true,
  pure: false,
})
export class CustomTimePipe implements PipeTransform {
  private lastValue: number;
  private translated: string;
  private langChangeSub: Subscription;

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
  ) {
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.updateTranslation(this.lastValue);
      this.cdr.markForCheck();
    });
  }

  transform(minutes: number): string {
    if (minutes !== this.lastValue) {
      this.updateTranslation(minutes);
    }
    return this.translated;
  }

  private updateTranslation(minutes: number): void {
    this.lastValue = minutes;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    let result = '';

    if (hours) {
      result +=
        hours +
        ' ' +
        (hours === 1 ? this.translate.instant('shared.units.hour') : this.translate.instant('shared.units.hours'));
      if (!remainingMinutes) {
        this.translated = result;
        return;
      }
    }

    result +=
      ' ' +
      remainingMinutes +
      ' ' +
      (remainingMinutes === 1
        ? this.translate.instant('shared.units.minute')
        : this.translate.instant('shared.units.minutes'));

    this.translated = result;
  }

  ngOnDestroy() {
    this.langChangeSub?.unsubscribe();
  }
}
